<template>
    <div class="material-table-expand" :class="{ other: params }">
        <div class="material-table-expand-con" v-loading="loading">
            <div class="material-table-expand-header" v-if="!params">
                <span>期望完成日期：{{ expandParams.expected_end_time }};</span>
                <span>投放场景：{{ expandParams.delivery_scene_name }};</span>
                <span>投放版位：{{ expandParams.delivery_type_name }};</span>
                <span v-if="expandParams.material_duration"
                    >素材时长：{{ expandParams.material_duration }}</span
                >
                <span
                    >素材标签：
                    <template
                        v-if="
                            expandParams.label_list &&
                            Array.isArray(expandParams.label_list) &&
                            expandParams.label_list.length !== 0
                        "
                    >
                        <span
                            v-for="(item, index) in expandParams.label_list"
                            :key="index"
                            class="pr6"
                            >{{ item.name }};</span
                        >
                    </template>
                    <span v-else>-</span>
                </span>
                <!-- <span
                    >制作人：
                    <template
                        v-if="
                            expandParams.producer &&
                            Array.isArray(expandParams.producer) &&
                            expandParams.producer.length !== 0
                        "
                    >
                        <span
                            v-for="(item, index) in expandParams.producer"
                            :key="index"
                            class="pr6"
                            >{{ item.num }} {{ item.user_name }};</span
                        >
                    </template>
                    <span v-else>-</span>
                </span> -->
            </div>
            <el-row
                class="tab-contant"
                type="flex"
                justify="space-between"
                align="middle"
            >
                <el-tabs
                    v-model="activeTableExpandName"
                    class="tabsMini"
                    @tab-click="handleClick"
                >
                    <el-tab-pane
                        :label="no_audit_num_text"
                        name="no_audit_list"
                    ></el-tab-pane>
                    <el-tab-pane
                        :label="in_rejected_num_text"
                        name="in_rejected_list"
                    ></el-tab-pane>
                    <el-tab-pane
                        :label="pass_num_text"
                        name="pass_list"
                    ></el-tab-pane>
                </el-tabs>
            </el-row>
            <div
                class="mb10 ml20 mt16"
                style="display: flex; align-items: center"
                v-if="list[activeTableExpandName].length != 0 && !params"
            >
                <div
                    v-if="
                        activeTableExpandName == 'in_rejected_list' &&
                        tagsActive == '4'
                    "
                ></div>
                <div v-else>
                    <el-button type="text" @click="handleSelect('all')"
                        >全选</el-button
                    ><span :style="{ padding: '0 6px' }">/</span>
                    <el-button type="text" @click="handleSelect('cannel')"
                        >反选</el-button
                    >
                </div>

                <div v-show="activeTableExpandName === 'no_audit_list'">
                    <el-button
                        type="success"
                        size="mini"
                        plain
                        v-if="getCurAuth('batch_pass_work_order')"
                        :style="{ marginLeft: '30px' }"
                        @click="handleGroupPass"
                        >批量通过</el-button
                    >
                    <el-button
                        type="danger"
                        size="mini"
                        v-if="getCurAuth('batch_deny_work_order')"
                        plain
                        @click="handleGroupReject('group')"
                        >批量拒绝</el-button
                    >
                    <el-button
                        type="primary"
                        size="mini"
                        v-if="getCurAuth('batch_download_material')"
                        plain
                        @click="handleGroupDown"
                        >批量下载</el-button
                    >
                </div>
                <div
                    v-show="
                        activeTableExpandName === 'in_rejected_list' &&
                        tagsActive != '4'
                    "
                >
                    <el-button
                        type="success"
                        size="mini"
                        plain
                        :style="{ marginLeft: '30px' }"
                        v-if="getCurAuth('batch_pass_work_order')"
                        @click="handleGroupPass"
                        >批量通过</el-button
                    >
                </div>
                <div v-show="activeTableExpandName === 'pass_list'">
                    <el-button
                        type="danger"
                        size="mini"
                        v-if="
                            getCurAuth('batch_deny_work_order') &&
                            tagsActive != '4'
                        "
                        :style="{ marginLeft: '30px' }"
                        plain
                        @click="handleGroupReject('group')"
                        >批量拒绝</el-button
                    >
                    <el-button
                        type="primary"
                        size="mini"
                        v-if="getCurAuth('batch_download_material')"
                        :style="{ marginLeft: '30px' }"
                        plain
                        @click="handleGroupDown"
                        >批量下载</el-button
                    >
                </div>
            </div>

            <div class="mb10 ml20 mt16" v-if="list[activeTableExpandName].length != 0 && params">
                <div
                    v-if="
                        activeTableExpandName == 'in_rejected_list' &&
                        tagsActive == '4'
                    "
                ></div>
                <div v-else>
                    <el-button type="text" @click="handleSelect('all')"
                        >全选</el-button
                    ><span :style="{ padding: '0 6px' }">/</span>
                    <el-button type="text" @click="handleSelect('cannel')"
                        >反选</el-button
                    >
                </div>
            </div>

            <div
                class="material-contant"
                v-if="list[activeTableExpandName].length != 0"
            >
                <div class="material-table-expand-cards">
                    <div
                        class="material-table-expand-cards-item"
                        v-for="(item, index) in list[activeTableExpandName]"
                        :key="index"
                    >
                        <MaterialExtendItem
                            :expandMaterial="item"
                            :preview="false"
                            @click-preview="handlePreView(item.id)"
                            :key="index"
                        >
                            <template v-slot:checkBox>
                                <div
                                    v-if="
                                        activeTableExpandName ==
                                            'in_rejected_list' &&
                                        tagsActive == '4'
                                    "
                                ></div>
                                <el-checkbox
                                    v-else
                                    :value="item.checked"
                                    @change="
                                        (value) => handleChange(value, index)
                                    "
                                ></el-checkbox>
                            </template>
                            <template v-slot:leftBtn>
                                <el-button
                                    type="primary"
                                    size="mini"
                                    v-if="
                                        getCurAuth('download_material') &&
                                        activeTableExpandName !=
                                            'in_rejected_list'
                                    "
                                    plain
                                    :loading="item.downloading"
                                    @click="handleOnlyDown(item)"
                                    >下载</el-button
                                >
                            </template>
                            <template v-slot:footer>
                                <div
                                    v-if="
                                        activeTableExpandName ===
                                            'no_audit_list' && tagsActive != '4'
                                    "
                                >
                                    <el-button
                                        type="primary"
                                        size="mini"
                                        v-if="getCurAuth('pass_work_order')"
                                        plain
                                        @click="handlePass(item.id)"
                                        >通过</el-button
                                    >
                                    <el-button
                                        type="danger"
                                        size="mini"
                                        v-if="getCurAuth('deny_work_order')"
                                        plain
                                        @click="
                                            () =>
                                                handleGroupReject('only', item)
                                        "
                                        >拒绝</el-button
                                    >
                                </div>
                                <div
                                    v-else-if="
                                        activeTableExpandName ===
                                            'in_rejected_list' &&
                                        tagsActive != '4'
                                    "
                                >
                                    <el-button
                                        type="primary"
                                        size="mini"
                                        v-if="getCurAuth('pass_work_order')"
                                        plain
                                        @click="handlePass(item.id)"
                                        >通过</el-button
                                    >
                                </div>
                                <div
                                    v-else-if="
                                        activeTableExpandName === 'pass_list' &&
                                        tagsActive != '4'
                                    "
                                >
                                    <el-button
                                        type="danger"
                                        size="mini"
                                        v-if="getCurAuth('deny_work_order')"
                                        plain
                                        @click="
                                            () =>
                                                handleGroupReject('only', item)
                                        "
                                        >拒绝</el-button
                                    >
                                </div>
                            </template>
                        </MaterialExtendItem>
                    </div>
                    <!--使用占位元素,补齐最后一行空缺的item,以保证最后一行的展示效果-->
                    <div
                        class="pad-material-table-expand-cards-item material-table-expand-cards-item"
                        v-for="index of padNum"
                        :key="index + activeTableExpandName"
                    ></div>
                </div>
            </div>
            <div v-else :style="{ textAlign: 'center', lineHeight: '60px' }">
                暂无数据
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex"
import MaterialExtendItem from "@/views/workOrder/components/materialExtendItem.vue"
import { cloneDeep } from "lodash"
import API from "@/api/workOrder/material.js"
import { storePreviewModal, storeUploadModal } from "@/views/workOrder/modal"
import {
    filterNullRejectModal,
    downLoadModal,
    settleModel,
    resultOnceModal,
    rejectModal,
    resultModal,
} from "../modalMaterial"
import { downloadFile } from "@/views/workOrder/components/utils.js"
export default {
    name: "materialInfo_tableExpand",
    components: {
        MaterialExtendItem,
    },
    props: [
        "orderId",
        "rows",
        "params",
        "pageFuncNames",
        "show_status",
        "tagsActive",
        "showBar",
    ],
    data() {
        return {
            activeTableExpandName: "no_audit_list",
            checked: true,
            list: {
                no_audit_list: [],
                in_rejected_list: [],
                pass_list: [],
            },
            // rows:{},
            expandParams: {},
            no_audit_num_text: "待审核",
            in_rejected_num_text: "已拒绝",
            pass_num_text: "已通过",
            expandMaterial: [],
            loading: false,
            padNum: 0,
        }
    },
    computed: {
        ...mapState({
            sidebarOpened: (state) => state.app.sidebar.opened,
        }),
    },
    watch: {
        "rows.id": {
            handler(val) {
                this.fetchInfo(val, "init")
            },
            deep: true,
            immediate: true,
        },
        // showBar() {
        //     setTimeout(() => {
        //         this.getPadNum()
        //     }, 300)
        // },
        // sidebarOpened() {
        //     setTimeout(() => {
        //         this.getPadNum()
        //     }, 300)
        // },
    },
    mounted() {
        document
            .querySelector(".tabsMini")
            .addEventListener("click", this.handleScroll)
        // this.getPadNum()
        // window.addEventListener("resize", this.getPadNum)
    },
    methods: {
        // getPadNum() {
        //     /* 动态计算最后一行的数量 */
        //     const width = document.querySelector(
        //         ".material-table-expand-con"
        //     )?.clientWidth
        //     // console.log('width',width);
        //     const rowNum = Math.floor(width / (300 + 10))
        //     if (this.list[this.activeTableExpandName].length % rowNum != 0) {
        //         let padNum =
        //             rowNum -
        //             (this.list[this.activeTableExpandName].length % rowNum)
        //         this.padNum = padNum
        //     } else {
        //         this.padNum = 0
        //     }
        // },
        handleScroll(e) {
            let target = e.target
            if (target.className.indexOf("el-tabs__item") > -1) {
                //数组取整
                let cur_top = parseInt(target.getBoundingClientRect().top)
                let curDom = document.querySelector(
                    ".scrollbar-wrapper-78778965"
                )
                let srollTop = parseInt(curDom.scrollTop)
                const targetPosition = srollTop + cur_top - 130
                if (targetPosition > 100) {
                    curDom.scrollTo({
                        top: targetPosition,
                        behavior: "smooth",
                    })
                } else {
                    curDom.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    })
                }
            }
        },
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name)
        },
        // 获取详情接口
        fetchInfo(id, type) {
            this.loading = true
            if (this.params) {
                return API.getWorkOrderMaterialByOrderList({
                    order_id: this.orderId,
                    ...this.params,
                })
                    .then(
                        (res) => {
                            this.expandParams = res.data
                            this.$nextTick(() => {
                                this.no_audit_num_text = `待审核（${
                                    this.expandParams?.no_audit_num
                                        ? this.expandParams?.no_audit_num
                                        : 0
                                }）`
                                this.in_rejected_num_text = `已拒绝（${
                                    this.expandParams?.in_rejected_num
                                        ? this.expandParams?.in_rejected_num
                                        : 0
                                }）`
                                this.pass_num_text = `已通过（${
                                    this.expandParams?.pass_num
                                        ? this.expandParams?.pass_num
                                        : 0
                                }）`
                                const list_keys = Object.keys(this.list)
                                // this.handleClick({name:'no_audit_list'})
                                let new_list = {}
                                list_keys.forEach((ele) => {
                                    let res_list = this.expandParams[ele]
                                        ? this.expandParams[ele]
                                        : []
                                    new_list[ele] = res_list.map((item) => {
                                        item["type"] = ele
                                        item["checked"] = false
                                        item["all_labels"] = (
                                            item.delete_labels || []
                                        ).concat(item.label_list || [])
                                        this.list[ele] &&
                                            this.list[ele].map((item2) => {
                                                item2["downloading"] = false
                                            })
                                        return item
                                    })
                                })
                                this.list = new_list
                                if (type === "init" && this.show_status) {
                                    // 初始化操作
                                    this.activeTableExpandName = this
                                        .show_status
                                        ? this.show_status
                                        : "no_audit_list"
                                }
                            })
                        },
                        (err) => {
                            this.$message.error(err.info)
                        }
                    )
                    .finally(() => {
                        this.loading = false
                        // this.getPadNum()
                    })
            } else {
                return API.getWorkOrderMaterialList({ detail_id: id })
                    .then(
                        (res) => {
                            this.expandParams = res.data
                            this.$nextTick(() => {
                                this.no_audit_num_text = `待审核（${
                                    this.expandParams?.material_list
                                        ?.no_audit_num
                                        ? this.expandParams?.material_list
                                              ?.no_audit_num
                                        : 0
                                }）`
                                this.in_rejected_num_text = `已拒绝（${
                                    this.expandParams?.material_list
                                        ?.in_rejected_num
                                        ? this.expandParams?.material_list
                                              ?.in_rejected_num
                                        : 0
                                }）`
                                this.pass_num_text = `已通过（${
                                    this.expandParams?.material_list?.pass_num
                                        ? this.expandParams?.material_list
                                              ?.pass_num
                                        : 0
                                }）`
                                const list_keys = Object.keys(this.list)
                                // this.handleClick({name:'no_audit_list'})
                                let new_list = {}
                                list_keys.forEach((ele) => {
                                    let res_list = this.expandParams
                                        ?.material_list[ele]
                                        ? this.expandParams?.material_list[ele]
                                        : []
                                    new_list[ele] = res_list.map((item) => {
                                        item["type"] = ele
                                        item["checked"] = false
                                        item["all_labels"] = (
                                            item.delete_labels || []
                                        ).concat(item.label_list || [])
                                        this.list[ele] &&
                                            this.list[ele].map((item2) => {
                                                item2["downloading"] = false
                                            })
                                        return item
                                    })
                                })
                                this.list = new_list
                                if (type === "init" && this.show_status) {
                                    // 初始化操作
                                    this.activeTableExpandName = this
                                        .show_status
                                        ? this.show_status
                                        : "no_audit_list"
                                }
                            })
                        },
                        (err) => {
                            this.$message.error(err.info)
                        }
                    )
                    .finally(() => {
                        this.loading = false
                        // this.getPadNum()
                    })
            }
        },
        // 折角矩形 标签点击
        handleClick(val) {
            // let res_list = this.expandParams?.material_list[val.name] ? this.expandParams?.material_list[val.name] : []
            // this.list[val.name] = res_list.map(item=>{item['type'] = val.name;item['checked'] = true; return item})
            // console.log('list', this.list)
            // this.getPadNum()
        },
        // 素材预览
        handlePreView(id) {
            const { vm } = storePreviewModal({
                props: {
                    id: id,
                    list: this.list[this.activeTableExpandName],
                    activeTabs: this.activeTableExpandName,
                    fetch: "getOrderPreview", //请求不同给的接口
                    authEdit: false,
                    authDown:
                        this.getCurAuth("download_material") &&
                        this.activeTableExpandName != "in_rejected_list"
                            ? true
                            : false,
                    downFetch: "postWorkOrderOnlyMaterialDownLoad",
                    authDownHref: `/td/api/work_order/download_material`,
                    authPass:
                        this.tagsActive != "4" &&
                        (this.activeTableExpandName === "no_audit_list" ||
                            this.activeTableExpandName ===
                                "in_rejected_list") &&
                        this.getCurAuth("pass_work_order")
                            ? true
                            : false,
                    authReject:
                        this.tagsActive != "4" &&
                        (this.activeTableExpandName === "no_audit_list" ||
                            this.activeTableExpandName === "pass_list") &&
                        this.getCurAuth("deny_work_order")
                            ? true
                            : false,
                },
                cbs: {
                    onSubmit: (data) => {
                        console.log("触发详情关闭", data)
                    },
                    onClose: () => {
                        console.log("触发详情关闭-close")
                        vm.close()
                    },
                    onPass: async (data) => {
                        let res = await this.fetchInfo(this.rows.id)
                        vm.$refs.componentVm._list =
                            this.list[this.activeTableExpandName]
                        this.$emit("reloadColumn", this.rows.id)
                    },
                    onReject: async (index) => {
                        // this.fetchInfo(this.rows.id)
                        let res = await this.fetchInfo(this.rows.id)
                        vm.$refs.componentVm._list =
                            this.list[this.activeTableExpandName]
                        this.$emit("reloadColumn", this.rows.id)
                        // return new Promise((resolve, reject) => {
                        //     setTimeout(()=>{
                        //         this.list[this.activeTableExpandName].splice(index, 1)
                        //         resolve()
                        //     }, 2000)
                        //
                        // })
                    },
                },
            })
        },
        // 设置 选中
        handleChange(value, index) {
            console.log(value, index)
            this.$set(this.list[this.activeTableExpandName], index, {
                ...this.list[this.activeTableExpandName][index],
                checked: value,
            })
        },
        // 全选 反选
        handleSelect(type) {
            let res_obj = []
            let cloneDeepList = cloneDeep(this.list[this.activeTableExpandName])
            if (type == "all") {
                if (cloneDeepList.every((item) => item["checked"])) {
                    res_obj = cloneDeepList.map((item) => {
                        item["checked"] = false
                        return item
                    })
                } else {
                    res_obj = cloneDeepList.map((item) => {
                        item["checked"] = true
                        return item
                    })
                }
            } else {
                res_obj = cloneDeepList.map((item) => {
                    item["checked"] = !item["checked"]
                    return item
                })
            }
            this.$set(this.list, this.activeTableExpandName, res_obj)
        },
        // 批量下载
        handleGroupDown() {
            let group_ids = this.list[this.activeTableExpandName]
                .filter((item) => item["checked"])
                .map((item) => item["id"])
            if (!group_ids || group_ids.length == 0) {
                return this.$message.warning("请选择素材后操作")
            }
            const { vm } = downLoadModal({
                props: {
                    id: group_ids,
                    fetch: "postWorkOrderDownLoad",
                },
                cbs: {
                    onSubmit: (data) => {
                        vm.close()
                    },
                },
            })
        },
        // 单独下载
        handleOnlyDown(row) {
            let index = this.list[this.activeTableExpandName].findIndex(
                (item) => item["id"] == row.id
            )
            this.$set(
                this.list[this.activeTableExpandName][index],
                "downloading",
                true
            )
            API.postWorkOrderOnlyMaterialDownLoad({ material_id: row.id })
                .then(
                    (res) => {
                        let result = res.data
                        downloadFile(result)
                    },
                    (err) => {
                        this.$message.error(err.info || "请求异常")
                    }
                )
                .finally(() => {
                    this.$set(
                        this.list[this.activeTableExpandName][index],
                        "downloading",
                        false
                    )
                })
        },
        // downloadFile(params) {
        //     let url = `/td/api/download?name=${encodeURIComponent(params.name)}&path=${encodeURI(params.path)}`
        //     try{
        //         let elemIF = document.createElement("iframe");
        //         elemIF.src = url;
        //         elemIF.style.display = "none";
        //         document.body.appendChild(elemIF);
        //         setTimeout(()=>{
        //             elemIF.remove();
        //         },1000*50)
        //     }catch(e){
        //         console.log('exportFile error',e);
        //     }
        // },
        // 批量拒绝
        handleGroupReject(type, params) {
            let group_ids = []
            if (type == "group") {
                let res_list = this.list[this.activeTableExpandName].filter(
                    (item) => item["checked"]
                )
                group_ids = res_list.map((item) => item["id"])
                if (!group_ids || group_ids.length == 0) {
                    return this.$message.warning("请选择素材后操作")
                }
                let list_0 = res_list.filter((item) => item.is_used == "0")
                let list_1 = res_list.filter((item) => item.is_used == "1")
                let no_is_used = res_list.every((item) => item.is_used == "1")
                if (no_is_used) {
                    return this.$message.warning("没有可以拒绝的素材")
                }
                if (list_1.length > 0) {
                    const { vm } = filterNullRejectModal({
                        props: {
                            list: list_1,
                        },
                        cbs: {
                            onSubmit: (data) => {
                                vm.close()
                                this.handleClearReject(list_0, type)
                            },
                        },
                    })
                } else {
                    this.handleClearReject(list_0, type)
                }
            } else {
                if (params.is_used == 1) {
                    return this.$message.error("素材已经使用，无法拒绝。")
                }
                group_ids = [params.id]
                const { vm } = rejectModal({
                    props: {
                        hasLoading: true,
                        id: group_ids,
                        type: type,
                    },
                    cbs: {
                        onSubmit: (data) => {
                            vm.close()
                            if(this.params) {
                                this.fetchInfo()
                            }else{
                                this.fetchInfo(this.rows.id)
                                this.$emit("reloadColumn", this.rows.id)
                            }
                        },
                    },
                })
            }
        },
        // 批量拒绝剔除 并通过
        handleClearReject(group_ids, type) {
            let ids = group_ids.map((item) => item["id"])
            const { vm } = rejectModal({
                props: {
                    id: ids,
                    type: type,
                },
                cbs: {
                    onSubmit: (data) => {
                        vm.close()
                        if(this.params) {
                            this.fetchInfo()
                        }else{
                            this.fetchInfo(this.rows.id)
                            this.$emit("reloadColumn", this.rows.id)
                        }
                    },
                },
            })
        },
        // 批量通过
        handleGroupPass() {
            let group_ids = this.list[this.activeTableExpandName]
                .filter((item) => item["checked"])
                .map((item) => item["id"])
            if (this.activeTableExpandName == "in_rejected_list") {
                // 已拒绝 弹出二次确认
                console.log("---")
            }
            if (!group_ids || group_ids.length == 0) {
                return this.$message.warning("请选择素材后操作")
            }

            if (this.activeTableExpandName === "no_audit_list") {
                API.postWorkOrderBatchPass({ material_id: group_ids }).then(
                    (res) => {
                        this.$message.success(res.info)
                        if(this.params) {
                            this.fetchInfo()
                        }else{
                            this.fetchInfo(this.rows.id)
                        }
                    },
                    (err) => {
                        this.$message.error(err.info)
                    }
                )
                return
            }
            const { vm } = resultModal({
                props: {
                    hasLoading: true,
                    id: group_ids,
                },
                cbs: {
                    onSubmit: (data) => {
                        vm.close()
                        if(this.params) {
                            this.fetchInfo()
                        }else{
                            this.fetchInfo(this.rows.id)
                            this.$emit("reloadColumn", this.rows.id)
                        }
                    },
                },
            })
        },
        // 通过
        handlePass(id) {
            if (this.activeTableExpandName === "no_audit_list") {
                API.postWorkOrderPass({ material_id: id }).then(
                    (res) => {
                        this.$message.success(res.info)
                        this.fetchInfo(this.rows.id)
                        this.$emit("reloadColumn", this.rows.id)
                    },
                    (err) => {
                        this.$message.error(err.info)
                    }
                )
                return
            }
            const { vm } = resultOnceModal({
                props: {
                    hasLoading: true,
                    id: id,
                },
                cbs: {
                    onSubmit: (data) => {
                        vm.close()
                        if(this.params) {
                            this.fetchInfo()
                        }else{
                            this.fetchInfo(this.rows.id)
                            this.$emit("reloadColumn", this.rows.id)
                        }
                    },
                },
            })
        },
    },
    beforeDestroy() {
        document.querySelector(".tabsMini") &&
            document
                .querySelector(".tabsMini")
                .removeEventListener("click", this.handleScroll)
        // window.removeEventListener("resize", this.getPadNum)
    },
}
</script>
<style lang="scss" scoped>
.material-table-expand {
    height: 100%;
    padding: 0 10px;

    .material-table-expand-con {
        height: 100%;
        background-color: #f1f4f9;
        border-radius: 8px; // 添加圆角
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); // 添加阴影
    }

    .material-table-expand-header {
        display: flex;
        flex-wrap: wrap;
        padding: 8px 10px 0;

        span {
            padding-right: 20px;
            padding-bottom: 6px;
        }
    }

    // .material-table-expand-cards {
    //     display: flex;
    //     flex-wrap: wrap;
    //     justify-content: space-evenly;

    //     .pad-material-table-expand-cards-item {
    //         background-color: transparent !important;
    //         width: 300px;
    //     }

    //     .material-table-expand-cards-item:not(.pad-material-table-expand-cards-item) {
    //         background-color: #fff;
    //         margin: 0 5px 10px 5px;
    //         border-radius: 8px; // 添加圆角
    //         box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); // 添加阴影
    //         transition: box-shadow 0.3s ease; // 添加过渡效果

    //         &:hover {
    //             box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); // 鼠标悬停时增强阴影
    //         }
    //     }
    // }
    .material-table-expand-cards{
        display: grid;
        grid-template-columns: repeat(auto-fill, 310px);
        gap: 20px;
        justify-content: center;
        .material-table-expand-cards-item {
            background-color: #fff;
            margin: 0 5px 10px 5px;
            border-radius: 8px; // 添加圆角
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); // 添加阴影
            transition: box-shadow 0.3s ease; // 添加过渡效果
        
            &:hover {
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); // 鼠标悬停时增强阴影
            }
        }
    }

    .pr6 {
        padding-right: 6px !important;
    }

    .tabsMini {
        flex: 1;
        background-color: #fff;
        padding-left: 20px;

        .el-tabs__item {
            font-size: 12px;
            line-height: 30px;
            height: 30px;
        }

        ::v-deep .el-tabs__header {
            margin-bottom: 0;
        }
    }

    &.other {
        padding: 0;
        .material-table-expand-con {
            display: flex;
            flex-direction: column;
            .tab-contant {
                background: #fff;
            }
            .material-contant {
                flex: 1;
                overflow-y: auto;
                height: 0;
                .material-table-expand-cards {
                    padding-top: 10px;
                }
            }
        }
    }
}
</style>
